export default function preloadImage(url) {
    return new Promise((resolve) => {
        const image = new Image();
        image.src = url;
        image.onload = () => {
            if (image.naturalWidth > 0 || image.naturalHeight > 0) {
                resolve(true);
            } else {
                resolve(false);
            }
        };

        image.onerror = () => {
            resolve(false);
        };
    });
}